const SimpleTextSection = ({ title, titleJP }) => {
  return (
    <div className="shop-list-section simple-text-section">
        <div className="container shop-main-section pt-0">
            <div className="last-content">
                <p className="text1 font-outfit">
                    {title}
                </p>
                <p className="text2 font-kleeone">
                    {titleJP}
                </p>
            </div>
        </div>
    </div>
  )
}

export default SimpleTextSection